import type { Flash } from '../types'

export default function FlashMessages({ flash }: { flash: Flash }) {
  if (!flash.notice && !flash.alert) return null

  return (
    <div className="mb-6 space-y-3">
      {flash.notice && (
        <p
          role="status"
          aria-atomic="true"
          className="rounded-md border border-notice-border bg-notice px-4 py-3 leading-relaxed wrap-break-word text-notice-ink"
        >
          {flash.notice}
        </p>
      )}
      {flash.alert && (
        <p
          role="alert"
          aria-atomic="true"
          className="rounded-md border border-alert-border bg-alert px-4 py-3 leading-relaxed wrap-break-word text-alert-ink"
        >
          {flash.alert}
        </p>
      )}
    </div>
  )
}
